// src/components/Main.jsx
import { useParams } from "react-router-dom";
import PageRenderer from "./templates/PageTemplate";
import { useState, useEffect } from "react";
import { IS_DEMO } from '../App';
export default function Main() {
  const { name } = useParams();

  // Stany trzech modalów
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);

  const [demoAccepted, setDemoAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  // Sprawdzamy localStorage przy montowaniu komponentu
  useEffect(() => {
    if (IS_DEMO) return;
    const demo = localStorage.getItem("demoNoticeAccepted");
    const terms = localStorage.getItem("termsNoticeAccepted");
    const admin = localStorage.getItem("adminNoticeAccepted");


    if (!demo) {
      setShowDemoModal(true);
    } else if (!terms) {
      setShowTermsModal(true);
    } else if (!admin) {
      setShowAdminModal(true);
    }
  }, []);

  // 1. Akceptacja modala demo
  const handleDemoAccept = () => {
    if (demoAccepted) {
      localStorage.setItem("demoNoticeAccepted", "true");
      setShowDemoModal(false);
      setShowTermsModal(true); // przechodzimy do kolejnego
    }
  };

  // 2. Akceptacja warunków współpracy
  const handleTermsAccept = () => {
    if (termsAccepted) {
      localStorage.setItem("termsNoticeAccepted", "true");
      setShowTermsModal(false);
      setShowAdminModal(true); // przechodzimy do ostatniego
    }
  };

// 3. Akceptacja i otwarcie panelu admina
const handleAdminAccept = (open = true) => {
  localStorage.setItem("adminNoticeAccepted", "true");
  setShowAdminModal(false);

  if (name && open) {
    window.open(`/${name}/admin`, "_blank");
  }
};


  return (
    <>
      <PageRenderer />

      {/* 1. Modal: To jest wersja demonstracyjna */}
      {showDemoModal && IS_DEMO &&(
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Wersja demonstracyjna
            </h2>

            <p className="text-gray-700 leading-relaxed mb-6">
              To jest <strong>przykładowa wersja strony</strong>, pokazująca jak może wyglądać gotowa realizacja.
              Treści i zdjęcia są fikcyjne i służą wyłącznie prezentacji.
            </p>

            <label className="flex items-center cursor-pointer select-none mb-6">
              <input
                type="checkbox"
                checked={demoAccepted}
                onChange={(e) => setDemoAccepted(e.target.checked)}
                className="w-5 h-5 text-emerald-600 rounded mr-3"
              />
              <span className="text-gray-800 font-medium">
                Rozumiem
              </span>
            </label>
            <button
              onClick={handleDemoAccept}
              disabled={!demoAccepted}
              className={`w-full py-4 rounded-lg font-bold text-white transition ${
                demoAccepted
                  ? "bg-emerald-600 hover:bg-emerald-700"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              Dalej
            </button>
          </div>
        </div>
      )}

      {/* 2. Modal: Warunki współpracy */}
      {showTermsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full p-8 max-w-3xl text-sm sm:text-base px-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Współpraca
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            Ta strona jest częścią <strong>propozycji współpracy</strong> z fotografem Maciejem.
            Obiekt poleca fotografa przy rezerwacji imprez, a w zamian otrzymuje:
          </p>

          <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-1">
            <li>Darmową stronę internetową dla obiektu</li>
            <li><strong>Pierwszą imprezę sfotografowaną za darmo</strong></li>
            <li>Prowizję od kolejnych zleceń</li>
            <li>Zdjęcia do użycia w social mediach</li>
          </ul>

          <p className="text-gray-700 leading-relaxed mb-4">
            Jedyny koszt po stronie obiektu to domena
            (~<strong>100 zł/rok</strong> za .pl, opłacana u operatora).
            Możliwa jest też darmowa subdomena.
          </p>

          <label className="flex items-center cursor-pointer select-none mb-4">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              className="w-5 h-5 text-emerald-600 rounded mr-3"
            />
            <span className="text-gray-800 font-medium">
              Rozumiem
            </span>
          </label>
            <button
              onClick={handleTermsAccept}
              disabled={!termsAccepted}
              className={`w-full py-4 rounded-lg font-bold text-white transition ${
                termsAccepted
                  ? "bg-emerald-600 hover:bg-emerald-700"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              Dalej
            </button>
          </div>
        </div>
      )}

      {/* 3. Modal: Panel administracyjny */}
{showAdminModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
    <div className="bg-white rounded-xl shadow-2xl w-full p-8 max-w-3xl text-sm sm:text-base px-4">
      <h2 className="text-2xl font-bold text-gray-800 mb-3">
        Panel administracyjny
      </h2>

      <p className="text-gray-700 leading-relaxed mb-3">
        Wszystkie treści na stronie (teksty, zdjęcia, sekcje) możesz 
        <strong> samodzielnie edytować</strong> w panelu admina.
      </p>

      <p className="text-gray-700 leading-relaxed mb-4">
        Po rozpoczęciu współpracy zapewniam darmowe poprawki
        oraz stałe wsparcie techniczne.
      </p>

      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-4">
        <p className="text-gray-800 text-sm">
          Panel demo jest dostępny również przez
          <strong> zielony przycisk w prawym dolnym rogu</strong>.
        </p>
      </div>

      <p className="text-gray-700 leading-relaxed mb-4 text-sm">
        Adres panelu:
        <br />
        <code className="bg-gray-100 px-2 py-1 rounded inline-block mt-1">
          {window.location.origin}/{name}/admin
        </code>
      </p>


      <button
        onClick={() => handleAdminAccept(true)}
        className="w-full py-4 rounded-lg font-bold text-white transition bg-emerald-600 hover:bg-emerald-700 mb-2"
      >
        Otwórz panel administracyjny teraz
      </button>

      <button
        onClick={() => handleAdminAccept(false)}
        className="w-full py-3 rounded-lg font-medium text-emerald-700 transition bg-emerald-50 hover:bg-emerald-100"
      >
        Otwórz panel administracyjny później
      </button>


    </div>

  </div>
)}
    </>
  );
}